// extracted by mini-css-extract-plugin
export default {"mCard":"IC-z","image":"JC-z","imageNoBackground":"KC-z","imageHasCategory":"LC-z","fullWidth":"MC-z"};